import { Component, ContentChild, ElementRef, ViewChild } from '@angular/core';

@Component({
	selector: 'toggle-password',
	template: '<ng-content></ng-content>'
})
export class TogglePassword {
	private _shown = false;

	password: HTMLElement;
	toggler: HTMLElement;

	ngAfterContentInit() {
		const parent = this.el.nativeElement;
		this.toggler = document.createElement('i');
		this.toggler.className = 'fa fa-eye-slash';
		this.toggler.addEventListener('click', () => {
			this.toggle();
		});
		parent.appendChild(this.toggler);
		this.password = parent.firstElementChild;
	}

	constructor(private el: ElementRef) {}

	toggle() {
		this._shown = !this._shown;
		if (this._shown) {
			this.password.setAttribute('type', 'text');
			this.toggler.className = 'fa fa-eye';
		} else {
			this.password.setAttribute('type', 'password');
			this.toggler.className = 'fa fa-eye-slash';
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/components/common/toggle-password/toggle-password.component.ts